import React from 'react'
import Page from '../components/Page'
import '../../node_modules/@syncfusion/ej2-base/styles/material.css'
import '../../node_modules/@syncfusion/ej2-icons/styles/material.css'
import '../../node_modules/@syncfusion/ej2-buttons/styles/material.css'
import '../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css'
import '../../node_modules/@syncfusion/ej2-inputs/styles/material.css'
import '../../node_modules/@syncfusion/ej2-lists/styles/material.css'
import '../../node_modules/@syncfusion/ej2-navigations/styles/material.css'
import '../../node_modules/@syncfusion/ej2-popups/styles/material.css'
import '../../node_modules/@syncfusion/ej2-richtexteditor/styles/material.css'
import { HtmlEditor, Image, Inject, Link, QuickToolbar, RichTextEditorComponent, Toolbar, NodeSelection } from '@syncfusion/ej2-react-richtexteditor'
import { UploaderComponent } from '@syncfusion/ej2-react-inputs/src/uploader'
import { Button, Card, CardBody, CardHeader, Col, Label, Row, Form, FormFeedback, FormGroup, FormText, Input, Table, Nav, NavItem, NavLink, TabContent, TabPane, Modal, ModalBody, ModalFooter, ModalHeader, ButtonGroup, Spinner } from 'reactstrap'
import { MdEdit, MdCancel, MdWarning, MdFormatListBulleted, MdFlag, MdLanguage, MdHome, MdAdd, MdCameraAlt, MdFileUpload, MdDone, MdClear, MdFilterList, MdCreate, MdDelete, MdEmail, MdSearch } from 'react-icons/md'
import { FaSearch } from 'react-icons/fa'
import { IconContext } from 'react-icons/lib'
import moment from 'moment-timezone'
import { Redirect } from 'react-router'
import StorageService from '../services/StorageService'
import classnames from 'classnames'
import axios from '../utils/posAxios'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import CrmCampaignForm from '../components/CrmCampaignForm'
import folder_img from '../assets/img/folder.png'

class CrmCampaignDetailPage extends React.Component {
  _isMounted = true
  constructor(props) {
    super(props)
    this.state = {
      isLoading: true,
      redirect: false,
      emailSending: false,
      modal: false,
      countModal: false,
      logModal: false,
      emailModal: false,
      confirmModal: false,
      isLoading: true,
      customerList: [],
      broadcast_id: this.props.match.params.id,
      broadcast_subject: '',
      broadcast_date: '',
      age: '',
      count: '',
      selectedId: '',
      selectedName: '',
      value: '',
      category: '',
      type: '',
      test_email: '',
      ready: '',
      dispatchLog: [],
      selectedData: '',
      dataList: [],
      email_list: [],
      custom_data: '',
      tag: '',
      fileUrl: [],
      customdatafilter: '',
      tagfilter: '',
      reply_email: '',
    }
    this.selection = new NodeSelection()
    this.toolbarSettings = {
      items: [
        'Bold',
        'Italic',
        'Underline',
        'StrikeThrough',
        'FontName',
        'FontSize',
        'FontColor',
        'BackgroundColor',
        'LowerCase',
        'UpperCase',
        '|',
        'Formats',
        'Alignments',
        'OrderedList',
        'UnorderedList',
        'Outdent',
        'Indent',
        '|',
        'CreateLink',
        'Image',
        '|',
        'ClearFormat',
        'Print',
        'SourceCode',
        'FullScreen',
        '|',
        'Undo',
        'Redo',
      ],
    }

    this.quickToolbarSettings = {
      image: ['Replace', 'Align', 'Caption', 'Remove', 'InsertLink', 'OpenImageLink', '-', 'EditImageLink', 'RemoveImageLink', 'Display', 'AltText', 'Dimension'],
    }
    this.imageSettings = {
      saveFormat: 'Base64',
      resize: true,
      // maxHeight: 300,
      // maxWidth: 300,
    }
  }

  componentDidMount() {
    //this.getDataType();
    this.getCampaignDetail()
    this.getDispatchLog()
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  countModal = () => () => {
    //this.CustomerSearch();
    return this.setState({
      countModal: !this.state.countModal,
    })
  }

  remove = i => {
    var array = [...this.state.fileUrl] // make a separate copy of the array
    array.splice(i, 1)
    this.setState({ fileUrl: array })
  }

  CustomerSearch(category) {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      category: category,
      customdatafilter: this.state.customdatafilter,
      tagfilter: this.state.tagfilter,
    }
    axios
      .post(url + ':3004/v1/customer/campaign/search', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          this.setState({
            isLoading: false,
            email_list: result.data ? result.data : [],
            count: result.data.length,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  handleOnChange = async value => {
    this.setState({ value: value.value })
    //
  }

  lengthInUtf8Bytes = async str => {
    // Matches only the 10.. bytes that are non-initial characters in a multi-byte sequence.
    var m = encodeURIComponent(str).match(/%[89ABab]/g)
    return str.length + (m ? m.length : 0)
  }

  handleAttachmentChange = event => {
    //console.log(this.state.fileUrl.length)
    // if (this.state.fileUrl.length > 0) {
    //   this.notificationSystem.addNotification({
    //     title: <MdWarning />,
    //     message: 'Only one attachmemt is allow',
    //     level: 'error',
    //     position: 'br',
    //     autoDismiss: 4,
    //     dismissible: 'click',
    //   })
    // } else {
    let reader = new FileReader()
    if (Object.keys(event.target.files).length == 0) {
      // Object is empty
    } else {
      let file = event.target.files[0]

      reader.onloadend = () => {
        this.setState({
          fileUrl: [...this.state.fileUrl, { name: file.name, type: file.type, data: reader.result }],
        })
      }

      reader.readAsDataURL(file)
    }
    //}
  }

  changeHandler = e => {
    let { name, value } = e.target
    this.setState({
      [name]: value,
    })
  }

  toggleConfirmModal = () => () => {
    return this.setState({
      confirmModal: !this.state.confirmModal,
    })
  }

  toggle = (action, id) => () => {
    return this.setState({
      modal: !this.state.modal,
      isEdit: id != undefined || (id != null && action == 'EDIT') ? true : false,
      selectedId: id != undefined || (id != null && action == 'EDIT') ? id : '',
    })
  }

  logModal = log => () => {
    return this.setState({
      logModal: !this.state.logModal,
      selectedData: log ? log : '',
    })
  }

  checkboxChangeHandler = event => {
    this.setState({
      [event.target.name]: !this.state[event.target.name],
    })
    this.CampaignReady(!this.state[event.target.name])
  }

  CampaignReady(ready) {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_API_URL
    const data = {
      session_key: user.session_key,
      broadcast_id: this.state.broadcast_id,
      ready: ready ? '1' : '0',
      updated_by: user.email,
    }
    axios
      .post(url + ':3001/v1/broadcast/Ready', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        let message = ready ? 'Campaign Ready To Dispatch' : 'Campaign Remove Ready To Dispatch'
        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: message,
          level: 'success',
          position: 'br',
          autoDismiss: 2,
          dismissible: 'click',
        })
        this.getCampaignDetail()
      })
      .catch(error => {
        alert(error)
      })
  }

  emailModal = () => () => {
    return this.setState({
      emailModal: !this.state.emailModal,
    })
  }

  email = e => {
    e.preventDefault()
    this.setState({
      emailSending: true,
    })
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_API_URL
    const data = {
      session_key: user.session_key,
      broadcast_id: this.state.broadcast_id,
      company_id: comp.CompanyID,
      email: this.state.test_email,
      send_by: user.email,
    }

    axios
      .post(url + ':3001/v1/broadcast/TestEmail', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Email sent successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })
        this.setState({ emailModal: false, emailSending: false })
      })
      .catch(error => {
        alert(error)
      })
  }

  closeModal = (title, message, level, reload) => {
    this.notificationSystem.addNotification({
      title: title,
      message: message,
      level: level,
      position: 'br',
      autoDismiss: 2,
      dismissible: 'click',
    })

    this.setState({
      modal: false,
    })

    if (reload) {
      window.location.reload()
    } else {
      this.getCampaignDetail()
    }
  }

  onImageSelect(args) {
    let imgSize = 2000000
    let sizeInBytes = args.filesData[0].size
    if (imgSize < sizeInBytes) {
      args.cancel = true
      alert('Please insert the image with size below 2MB')
    }
  }

  updateBroadcastMessage = async () => {
    this.setState({ isLoading: true })
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_API_URL
    const data = {
      session_key: user.session_key,
      broadcast_id: this.state.broadcast_id,
      broadcast_subject: this.state.broadcast_subject,
      broadcast_date: this.state.broadcast_date,
      category: this.state.category,
      customdatafilter: this.state.customdatafilter,
      tagfilter: this.state.tagfilter,
      count: this.state.count,
      message: this.state.value,
      fileUrl: this.state.fileUrl,
    }

    console.log(this.state.fileUrl)

    let size = await this.lengthInUtf8Bytes(this.state.value + JSON.stringify(this.state.fileUrl))
    console.log(size)
    if (size > 2500000) {
      this.notificationSystem.addNotification({
        title: <MdWarning />,
        message: 'Message limit to 2.5MB',
        level: 'error',
        position: 'br',
        autoDismiss: 4,
        dismissible: 'click',
      })
      this.setState({ isLoading: false })
    } else {
      axios
        .post(url + ':3001/v1/broadcast/Edit', data)
        .then(response => {
          const result = response.data
          if (result.error == true && result.message != 'Success') {
            alert(result.message)
            return
          }

          this.notificationSystem.addNotification({
            title: <MdDone />,
            message: 'Broadcast updated successfully.',
            level: 'success',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          })

          this.getCampaignDetail()
        })
        .catch(error => {
          alert(error)
        })
    }
  }

  getDispatchLog = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_API_URL
    const data = {
      session_key: user.session_key,
      broadcast_id: this.state.broadcast_id,
    }

    axios
      .post(url + ':3001/v1/broadcast/DispatchLog', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          this.setState({
            dispatchLog: result.data,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  getCampaignDetail = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_API_URL
    const unity_url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: user.session_key,
      company_id: comp.CompanyID,
      broadcast_id: this.state.broadcast_id,
    }

    axios
      .post(url + ':3001/v1/broadcast/Detail', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        console.log(result)
        if (this._isMounted) {
          this.setState({
            broadcast_subject: result.data.broadcast_subject,
            broadcast_date: moment(result.data.broadcast_date).tz('Asia/Singapore').format('YYYY-MM-DD'),
            category: result.data.category,
            customdatafilter: result.data.customdatafilter,
            tagfilter: result.data.tagfilter,
            value: result.data.message,
            ready: result.data.ready,
            fileUrl: result.data.attachment ? JSON.parse(result.data.attachment) : [],
            reply_email: result.data.reply_email,
            //isLoading: false,
          })
          return result.data.category
        }
      })
      .then(category => {
        if (this._isMounted) {
          this.CustomerSearch(category)
        }
      })
      .catch(error => {
        console.log(error)
        alert(error)
      })
  }

  delete = () => {
    const user = StorageService.getSession('user_info')
    const url = process.env.REACT_APP_API_URL

    const data = {
      session_key: user.session_key,
      broadcast_id: this.state.broadcast_id,
      delete_by: user.email,
    }

    axios
      .post(url + ':3001/v1/broadcast/Delete', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.notificationSystem.addNotification({
            title: <MdClear />,
            message: result.message,
            level: 'error',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          })
          return
        }

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Broadcast deleted successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })
        this.setState({ confirmModal: false })
        setTimeout(() => {
          this.props.history.push('/crmcampaign')
        }, 1000)
      })
      .catch(error => {
        alert(error)
      })
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/" />
    }

    console.log(this.state.fileUrl)

    const logList = this.state.dispatchLog.map((item, index) => {
      return (
        <tr key={index}>
          <td>{moment(item.datetime).tz('Asia/Singapore').format('YYYY-MM-DD')}</td>
          <td>
            <div className="ps-action-button">
              <Button className="theme-button theme-button-secondary" onClick={this.logModal(item.log)}>
                View
              </Button>
            </div>
          </td>
        </tr>
      )
    })

    return (
      <Page
        className="CrmCampaignDetailPage"
        title="Campaign Detail"
        breadcrumbs={[
          { name: 'Campaign', active: false, path: '/crmcampaign' },
          { name: 'Detail', active: true, path: '/crmcampaigndetail' },
        ]}>
        <NotificationSystem dismissible={false} ref={notificationSystem => (this.notificationSystem = notificationSystem)} style={NOTIFICATION_SYSTEM_STYLE} />
        {this.state.isLoading && (
          <div
            style={{
              position: 'fixed',
              top: '50%',
              left: '50%',
              marginTop: '-24px',
              marginLeft: '-24px',
              zIndex: 2,
            }}>
            <Spinner animation="border" variant="primary" />
          </div>
        )}

        <Row>
          <Col className="ps-flex v-center">
            {/* <Button className="theme-button theme-button-secondary">
              Send Test
            </Button> */}
            <Button color="link" onClick={this.emailModal()}>
              <IconContext.Provider value={{ color: '#2a2c6b' }}>
                <MdEmail size={36} />
              </IconContext.Provider>
            </Button>
            <FormGroup check>
              <Label check>
                <Input type="checkbox" name="ready" checked={this.state.ready} onChange={this.checkboxChangeHandler} /> <small>Ready To Dispatch</small>
              </Label>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col xl={12} lg={12} md={12}>
            <Card className="ps-card-display">
              <CardHeader className="d-flex align-items-center justify-content-between ps-bg-gradient">
                Campaign Information
                <ButtonGroup>
                  <Button className="theme-button theme-button-secondary" onClick={this.toggle('EDIT', this.state.broadcast_id)}>
                    <MdEdit />
                    Edit
                  </Button>
                  <Button className="theme-button theme-button-secondary" onClick={this.toggleConfirmModal()}>
                    <MdDelete />
                    Delete
                  </Button>
                </ButtonGroup>
              </CardHeader>
              <CardBody>
                <Row form>
                  <Col lg={4}>
                    <Label>Subject</Label>
                    <p>{this.state.broadcast_subject}</p>
                  </Col>
                  <Col lg={4}>
                    <Label>Schedule Date</Label>
                    <p>{this.state.broadcast_date} &nbsp; 22:00:00</p>
                  </Col>
                  <Col lg={4}>
                    <Label>Category</Label>
                    <p>{this.state.category}</p>
                  </Col>

                  {/* <Col lg={4}>
                    <Label>Type</Label>
                    <p>{this.state.type}</p>
                  </Col> */}
                  {/* <Col lg={4}>
                    <Label>Age</Label>
                    <p>{this.state.age}</p>
                  </Col> */}
                  <Col lg={4}>
                    <Label>Custom Data</Label>
                    <p>{this.state.customdatafilter}</p>
                  </Col>
                  <Col lg={4}>
                    <Label>Tag</Label>
                    <p>{this.state.tagfilter}</p>
                  </Col>
                  <Col lg={4}>
                    <Label>Count </Label>
                    <p>
                      {this.state.count}{' '}
                      <Button style={{ padding: '0px 5px 5px 5px' }} color="link" onClick={this.countModal()}>
                        <IconContext.Provider value={{ color: '#2a2c6b' }}>
                          <MdSearch size={16} />
                        </IconContext.Provider>
                      </Button>
                    </p>
                  </Col>
                  <Col lg={4}>
                    <Label>Reply Email</Label>
                    <p>{this.state.reply_email}</p>
                  </Col>
                  {/* <Col lg={3}>
                    <Label>Tag</Label>
                    <Input
                      name="tag"
                      value={this.state.tag}
                      onChange={this.changeHandler}
                    />
                  </Col>
                  <Col lg={3}>
                    <Button>Search</Button>
                    <Button
                      color="link"
                      style={{ padding: '2px 0px 7px 5px' }}
                      onClick={() => this.CustomerSearch()}
                    >
                      <IconContext.Provider value={{ color: '#2a2c6b' }}>
                        <FaSearch size={14} />
                      </IconContext.Provider>
                    </Button>
                  </Col> */}
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col xl={12} lg={12} md={12}>
            <Card className="ps-card-display main">
              <CardBody>
                <RichTextEditorComponent height={650} toolbarSettings={this.toolbarSettings} imageSelected={this.onImageSelect} insertImageSettings={this.imageSettings} quickToolbarSettings={this.quickToolbarSettings} value={this.state.value} change={this.handleOnChange}>
                  <Inject services={[Toolbar, Image, Link, HtmlEditor, QuickToolbar]} />
                </RichTextEditorComponent>
                <br />
                <Row>
                  <Col md={12}>
                    <div>
                      <Input type="file" name="file" id="file" className="ps-input-file" onChange={this.handleAttachmentChange} />
                      <Label for="file">
                        <MdFileUpload /> Upload Attachment
                      </Label>
                    </div>
                    <div className={`ps-photo ${this.state.fileUrl.length < 1 ? ' empty' : ''}`}>
                      {this.state.fileUrl.length < 1 && <p>No attachment</p>}
                      {this.state.fileUrl.length > 0 &&
                        this.state.fileUrl.map((item, index) => {
                          return (
                            item.data !== '' && (
                              <div className="image" key={index}>
                                <MdCancel className="remove" onClick={() => this.remove(index)} />
                                {item.type.includes('image') ? (
                                  <img src={item.data} alt="logo" />
                                ) : (
                                  <>
                                    <img src={folder_img} alt="logo" />
                                    <p>{item.name}</p>
                                  </>
                                )}
                              </div>
                            )
                          )
                        })}
                    </div>
                  </Col>
                </Row>

                <br />
                <div className="ps-btn-group text-right">
                  <Button className="theme-button theme-button-primary" onClick={this.updateBroadcastMessage}>
                    Save
                  </Button>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col>
            <Card className="ps-card-display main">
              <CardHeader className="d-flex align-items-center justify-content-between ps-bg-gradient">Dispatch Log</CardHeader>
              <CardBody>
                <Table responsive hover className="ps-table tb-col-9 th-no-wrap">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.dispatchLog.length < 1 ? (
                      <tr>
                        <td colSpan="9">
                          <div className="ps-empty-data">
                            <div className="empty-content">
                              <MdCreate />
                              <h4>No data to show</h4>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ) : (
                      logList
                    )}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Modal isOpen={this.state.modal} toggle={this.toggle()} className={this.props.className} centered>
          <CrmCampaignForm history={this.props.history} onToggleModal={this.toggle} closeModal={this.closeModal} match={this.props.match} data={this.state} />
        </Modal>
        <Modal isOpen={this.state.confirmModal} toggle={this.toggleConfirmModal()} className={this.props.className} centered style={{ fontSize: '0.85rem' }}>
          <ModalHeader toggle={this.toggleConfirmModal()}>Delete Broadcast</ModalHeader>
          <ModalBody>
            <Row>
              <Col md={12}>
                <p>Are you sure you want to delete {this.state.broadcast_subject} ?</p>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button className="theme-button theme-button-secondary" onClick={this.toggleConfirmModal()}>
              No
            </Button>
            <Button className="theme-button theme-button-primary" onClick={() => this.delete()}>
              Yes
            </Button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.emailModal} toggle={this.emailModal()} className={this.props.className} centered style={{ fontSize: '0.85rem' }}>
          <Form onSubmit={this.email}>
            <ModalHeader toggle={this.emailModal()}>Send Test Email</ModalHeader>
            <ModalBody>
              <Row>
                <Col md={12}>
                  <FormGroup>
                    <Input type="text" name="test_email" value={this.state.test_email} onChange={this.changeHandler} required />
                  </FormGroup>
                </Col>
              </Row>
              {this.state.emailSending && (
                <div
                  style={{
                    position: 'absolute',
                    left: '50%',
                    marginLeft: -16,
                  }}>
                  <Spinner animation="border" variant="primary" />
                </div>
              )}
            </ModalBody>
            <ModalFooter>
              <Button className="theme-button theme-button-primary" type="submit">
                Send
              </Button>
            </ModalFooter>
          </Form>
        </Modal>
        <Modal isOpen={this.state.logModal} toggle={this.logModal(this.state.selectedData)} className={this.props.className} centered style={{ fontSize: '0.85rem' }}>
          <Form>
            <ModalHeader toggle={this.logModal()}>Log Detail</ModalHeader>
            <ModalBody style={{ maxHeight: 500, overflowY: 'auto' }}>
              {this.state.selectedData.split('<br/>').map((str, index) => {
                return <p key={index}>{str}</p>
              })}
            </ModalBody>
            <ModalFooter>
              <Button className="theme-button theme-button-primary" onClick={this.logModal()}>
                OK
              </Button>
            </ModalFooter>
          </Form>
        </Modal>
        <Modal isOpen={this.state.countModal} toggle={this.countModal()} centered style={{ fontSize: '0.85rem' }}>
          <Form>
            <ModalHeader toggle={this.countModal()}>Customer List</ModalHeader>
            <ModalBody style={{ maxHeight: 500, overflowY: 'auto' }}>
              {this.state.email_list.length > 0 &&
                this.state.email_list.map((item, index) => {
                  return (
                    <p key={index}>
                      {item.name} - {item.email}
                    </p>
                  )
                })}
              {this.state.email_list.length < 1 && <p>No Data Found</p>}
            </ModalBody>
          </Form>
        </Modal>
      </Page>
    )
  }
}

export default CrmCampaignDetailPage
